export default "__VITE_ASSET__rsWdPgGk__"